import React from 'react'
import { Stack, Typography } from '@mui/material'
import MiniLoader from './mini-loader'

interface MiniLoaderLabelProps {
  label: string
  loading: boolean
}

const MiniLoaderLabel: React.FC<MiniLoaderLabelProps> = ({ label, loading }) => {
  return (
    <Stack direction='row' gap={1} alignItems={'center'}>
      <Typography>{label}</Typography>
      {loading && <MiniLoader/>}
    </Stack>
  )
}

export default React.memo(MiniLoaderLabel)
